var map = {
	"./bg": 11,
	"./bg.jpg": 11,
	"./logo": 12,
	"./logo.svg": 12,
	"./logo2": 13,
	"./logo2.png": 13,
	"./logo_r": 14,
	"./logo_r.png": 14,
	"./post-placeholder": 15,
	"./post-placeholder.jpg": 15,
	"./post-placeholder2": 16,
	"./post-placeholder2.jpg": 16,
	"./trianglify": 17,
	"./trianglify.png": 17,
	"./undraw_color_palette_yamk": 18,
	"./undraw_color_palette_yamk.svg": 18,
	"./undraw_contrast_vb82": 19,
	"./undraw_contrast_vb82.svg": 19,
	"./undraw_filter_4kje": 20,
	"./undraw_filter_4kje.svg": 20,
	"./workstation": 21,
	"./workstation.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;